module.exports = __webpack_public_path__ + "static/img/didatravel.0252976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/partners/didatravel.png
// module id = 2FaS
// module chunks = 3